import Vue from 'vue'
import VueCookies from 'vue-cookies'
import * as types from './mutation-types'
Vue.use(VueCookies)

export default {
  [types.SET_BUSINESS] (state, data) {
    state.Business = data
    state.StatusBusiness = true
  },
  [types.SET_DATA_BOT_ONEPLATFORM] (state, data) {
    state.DataBotOnePlatform = data
  },
  [types.SET_UPDATE_BOT] (state, data) {
    state.DataUpdateBot = data
  },
  [types.SET_DATA_ANNOUNCE] (state, data) {
    state.DataAnnounce = data
  },
  [types.SET_DATA_GROUP_ONECHAT] (state, data) {
    state.DataGroupOneChatSearch = data
  },
  [types.SET_DATA_CHECK_USER] (state, data) {
    state.DataCheckUser = data
  },
  [types.SET_CHECKROLE] (state, data) {
    state.DataCheckRole = data
  },
  [types.GET_MENU_DEFAULT] (state, data) {
    state.MenuToolbarDefault = data
  },
  [types.GET_ROLE_ACCESS] (state, data) {
    state.DataAllRoleAccess = data
  },
  [types.SET_LOADING_LOGIN] (state, data) {
    state.LoadingLogin = data
  },
  [types.SET_ALLBUSINESS] (state, data) {
    state.AllBusiness = data
  },
  [types.SET_ROLEACCOUNT] (state, data) {
    state.RoleAccount = data
  },
  [types.SET_DATA_ACCOUNT] (state, data) {
    state.DataAccount = data
  },
  [types.SET_DATAPOLICY] (state, data) {
    state.DataPolicy = data
  },
  [types.SET_DATAPETITON] (state, data) {
    state.DataPetition = data
  },
  [types.SET_DATACONSENT] (state, data) {
    state.DataConsent = data
  },
  [types.SET_DATACONSENTID] (state, data) {
    state.DataConsentId = data
  },
  [types.SET_DATA_SMTP_EMAIL] (state, data) {
    state.DataSmtpEmail = data
  },

  [types.SET_DATA_CONSENT_ONECHAT] (state, data) {
    state.DataGroupConsentOnechat = data
  },
  [types.SET_DATA_CONSENT_ONECHAT_PATH] (state, data) {
    state.DataGroupConsentOnechatPath = data
  },
  [types.SET_DATA_GENERAL_DASHBOARD] (state, data) {
    state.DataGeneralDashboard = data
  },
  [types.SET_DATA_GROUP_DASHBOARD] (state, data) {
    state.DataGroupDashboard = data
  },
  [types.SET_DATA_CONSENT_GROUP] (state, data) {
    state.DataConsentGroup = data
  },
  [types.SET_DATA_GENERAL_CONSENT] (state, data) {
    state.DataGeneralConsent = data
  },
  [types.SET_DATA_GROUP_CONSENT] (state, data) {
    state.DataGroupConsent = data
  },
  [types.SET_MENU] (state, data) {
    state.MenuToolbar = data
  },
  [types.GET_MENU_DEFAULT] (state, data) {
    state.MenuToolbarDefault = data
  },
  [types.SET_STATUS_BUSINESS] (state, data) {
    state.StatusBusiness = true
  },
  [types.AUTH_PORTAL_CHECK] (state, data) {
    state.RefreshToken = data
    state.AccessToken = ''
    state.Authen = false
    state.Profile = state.Profile
  },
  [types.AUTH_PORTAL_SUCCESS] (state, data) {
    state.RefreshToken = state.RefreshToken
    state.AccessToken = state.AccessToken
    state.Authen = true
    state.Profile = data
  },
  [types.AUTH_PORTAL_EXPIRED] (state) {
    state.RefreshToken = ''
    state.AccessToken = ''
    state.Authen = false
    state.Profile = {}
  },

  [types.ACCOUNT_PORTAL_CHECK] (state, data) {
    state.RefreshToken = state.RefreshToken
    state.AccessToken = state.AccessToken
    state.Authen = state.Authen
    state.Profile = state.Profile
  },

  [types.ACCOUNT_PORTAL_SUCCESS] (state, data) {
    state.RefreshToken = state.RefreshToken
    state.AccessToken = state.AccessToken
    state.Authen = state.Authen
    state.Profile = data
  },

  [types.ACCOUNT_PORTAL_NOTFOUND] (state, data) {
    state.RefreshToken = ''
    state.AccessToken = ''
    state.Authen = false
    state.Profile = {}
  }
}
